import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
@Component
export default class ToolbarButton extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    /**
     * Text to display on the button
     */
    @Prop({ type: String, default: '' }) text!: string;

    /**
     * 등록, 저장 등의 버튼등에서 강조
     */
    @Prop({ type: Boolean, default: false }) primary!: boolean;

    /**
     * 강조가 아닌 버튼의 선택을 나타냄
     */
    @Prop({ type: Boolean, default: false }) selected!: boolean;
}
